import { IModuleLayoutConfig } from '../models/module-layout.model';
import { moduleConfig } from '../../../redux/reducers';
import { createSelector } from '@ngrx/store';

export const moduleLayout = (props: { name: string }) => createSelector(
  moduleConfig(props),
  state =>
  ({
    isLoading: state.isLoading,
    layout: (state.config && state.config['layout']) || []
  } as IModuleLayoutConfig)
);
